module.exports = __webpack_public_path__ + "media/tags/smartsearch/orange-minus-b6beedc14fad4bb33d6ef7ace0f815a4.png";